export default __webpack_public_path__ + "static/media/SWT0150.34I-21101_-14871_0.ee013a24.jpg";